var map = {
	"./interactive.eot": 56,
	"./interactive.svg": 57,
	"./interactive.ttf": 58,
	"./interactive.woff": 59,
	"./interactive.woff2": 60
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;


//////////////////
// WEBPACK FOOTER
// ./src/fonts ^\.\/.*\.*
// module id = 80
// module chunks = 0